import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPrinterOutline = function SvgPrinterOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 3.5C8.05964 3.5 7.5 4.05964 7.5 4.75V6H16.5V4.75C16.5 4.05964 15.9404 3.5 15.25 3.5H8.75ZM18 6V4.75C18 3.23122 16.7688 2 15.25 2H8.75C7.23122 2 6 3.23122 6 4.75V6H4.75C3.23122 6 2 7.23122 2 8.75V15.25C2 16.7688 3.23122 18 4.75 18H6V19.25C6 20.7688 7.23122 22 8.75 22H15.25C16.7688 22 18 20.7688 18 19.25V18H19.25C20.7688 18 22 16.7688 22 15.25V8.75C22 7.23122 20.7688 6 19.25 6H18ZM18 16.5H19.25C19.9404 16.5 20.5 15.9404 20.5 15.25V8.75C20.5 8.05964 19.9404 7.5 19.25 7.5H4.75C4.05964 7.5 3.5 8.05964 3.5 8.75V15.25C3.5 15.9404 4.05964 16.5 4.75 16.5H6V13.75C6 13.3358 6.33579 13 6.75 13H17.25C17.6642 13 18 13.3358 18 13.75V16.5ZM7.5 14.5V19.25C7.5 19.9404 8.05964 20.5 8.75 20.5H15.25C15.9404 20.5 16.5 19.9404 16.5 19.25V14.5H7.5ZM6 10.75C6 10.3358 6.33579 10 6.75 10H9.25C9.66421 10 10 10.3358 10 10.75C10 11.1642 9.66421 11.5 9.25 11.5H6.75C6.33579 11.5 6 11.1642 6 10.75Z"
  })));
};

export { SvgPrinterOutline as ReactComponent };
//# sourceMappingURL=printer-outline.svg.js.map
